module.exports = __webpack_public_path__ + "static/media/material_arrow_down.d35eaaa6.svg";